import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Row from "../../common/Row";
import Files from "../../common/Files";
import Fieldset from "../../common/Fieldset";
import SelectInput from "../../common/SelectInput";

const UiInVlaanderenForm = (props) => {
    const {
        onSave,
        onDropFiles,
        onTochtTypeChange,
        disabled,
        fotoFileTypes,
        color,
        fileName,
        tochtTypes,
        tochtTypeId
    } = props;

    function getFilesComponentPropsFoto(title, componentName, downloadFunction, documents, isDownloadOnly, onDrop, onDelete, fileTypes, center, validationMessageType, validationMessage, color, size) {

        const mappedOnDrop = (componentName) => {
            return (files) => onDrop(componentName, files);
        };

        return {
            title: title,
            componentName: componentName,
            color: color,
            fileTypes: fileTypes,
            downloadFunction: downloadFunction,
            files: documents,
            onDrop: mappedOnDrop(componentName),
            onDelete: null,
            isDownloadOnly: isDownloadOnly,
            center: center === undefined || !center ? false : center,
            validationMessageType: validationMessageType,
            validationMessage: validationMessage,
            size: size === undefined ? null : size,
            pollingEnabled: false
        };
    }


    let files = [{
        display: fileName
    }];

    const fotoFilesProps = getFilesComponentPropsFoto(
        "Foto",
        "Foto",
        null,
        files,
        false,
        onDropFiles,
        null,
        fotoFileTypes,
        true,
        null,
        null,
        color,
        6);

    return (
        <Fragment>
            <Form
                name="uiInVlaanderenForm"
                title={"Foto per tochttype opladen bij UiT in Vlaanderen"}
                leftButtonLabel={"Bewaar"}
                leftButtonDisabled={disabled}
                onLeftButtonClick={onSave}
            >
                <Fieldset>
                    <Row>
                        <SelectInput
                            name="tochtTypeId"
                            label="Tochttype"
                            items={tochtTypes}
                            onChange={onTochtTypeChange}
                            disabled={disabled}
                            value={tochtTypeId}
                        />
                    </Row>
                    <Row>
                        <Files
                            {...fotoFilesProps}
                            disabled={disabled}
                            optional={false} />
                    </Row>
                </Fieldset>
            </Form>
        </Fragment>
    );
};

UiInVlaanderenForm.propTypes = {
    onSave: PropTypes.func,
    onDropFiles: PropTypes.func,
    onTochtTypeChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    fotoFileTypes: PropTypes.object,
    color: PropTypes.string,
    fileName: PropTypes.string,
    tochtTypes: PropTypes.array.isRequired,
    tochtTypeId: PropTypes.string
};

export default UiInVlaanderenForm;
